import { Pipe, PipeTransform } from '@angular/core';
import { Recurrence } from '../models/event';
import { EventRecurrenceRepeatLanguageService } from '../services/event-recurrence-repeat-language.service';

@Pipe({
  name: 'repeatLanguage',
  pure: false,
})
export class SchedulesRepeatPipe implements PipeTransform {
  constructor(private eventRecurrenceRepeatLanguageService: EventRecurrenceRepeatLanguageService) {}

  transform(recurrence: Recurrence, recurrenceEnd?: string | Date): string {
    if (!recurrence) {
      return '';
    }

    return this.eventRecurrenceRepeatLanguageService.getRepeatLanguage(recurrence, recurrenceEnd);
  }
}
